import { render, staticRenderFns } from "./IconInitiator.vue?vue&type=template&id=18ca350f"
import script from "./IconInitiator.vue?vue&type=script&lang=js"
export * from "./IconInitiator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports